/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />
/// <reference path="../../_ext/Bases/DialogBase.ts" />
/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.Inventory {

    import fld = SKUItemsRow.Fields;
    @Serenity.Decorators.registerClass() 
    export class SKUPrintingEditor extends _Ext.ItemGridEditor<SKUItemsRow> {


        protected getColumnsKey() { return "Inventory.SKUPrintItem"; }
        protected getDialogType() { return SKUItemsDialog; }
        protected getLocalTextPrefix() { return SKUItemsRow.localTextPrefix; }
        protected form: SKUItemsForm;
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = true;
            opt.ShowRowNumberColumn = false;
            opt.ShowPrintInlineButtun = true;
            return opt;
        }
        private pendingChanges: Q.Dictionary<any> = {};

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as SKUGenerationDialog).setStockItemGrid(this.view.getItems());
                }
            });
        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var pieces = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Pieces).format = pieces;


            let weightColumn = Q.first(columns, x => x.field == fld.Weight);

            weightColumn.format = ctx => {
                if (ctx.item.HasBom == false)
                    return ColumnFormatter.WeightFormatter(ctx, this);
                else
                    return ColumnFormatter.ReadonlynumericInputFormatter(ctx,this);
            }
            //Q.first(columns, x => x.field === fld.Print).format = ctx => '<a class="inline-action add-button print-sku" href="#"><span></span>Genrate SKU</a>';
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            //To Add Delete Button on Item Row
            columns.push({
                field: 'Print SKU',
                name: '',
                format: ctx => '<a class="inline-action print-row" title="print">' +
                    '<i class="fa fa-print"></i></a>',
                width: 90,
                minWidth: 90,
                maxWidth: 90
            });
            return columns;
        }

        // #endregion

        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.view.deleteItem(id);

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        //Set Data for New SKU Generated 
        public setData(item: any[]) {
            for (var i = 0; i < item.length; i++) {
                //item.TransItemId = this.nextId++;
                item[i][this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item[i]);
            }

        }

        public setOldItems(entity: any[]) {
            for (var i = 0; i < entity.length; i++) {
                entity[i][this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(entity[i]);
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;
            let itemstock;
            Stock.StockItemService.GetProductDetails({ ProductId: item.ProductId, AttributeId: item.AttributeId, SKU: item.SKU, Studded: 0, LotNo: item.LotNo, Line_No: item.Line_No }, response => itemstock = response.Entity, { async: false })
            var items = (this.parentDialog as SKUGenerationDialog).form.PrintingDetails.getItems();
            var itemsweight = 0;
            var itemspieces = 0;
            items.forEach(a => itemsweight += a.Weight);
            items.forEach(a => itemspieces += a.Pieces);
            itemspieces -= item.Pieces;
            itemsweight -= item.Weight;
            // *** Validate Decimal & Integer***
            if (field === fld.Pieces) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3)
                    item.GrossAmount = item.UnitRate * value;
                if ((itemspieces + value) <= itemstock.Pieces) {
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;

                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    item[field] = value;
                }
                this.view.updateItem(id, item);
                this.view.refresh();
            }
            if (field === fld.Weight && value > 0) {

                if (item.CalcOnId == 4 || item.CalcOnId==5)
                    item.GrossAmount = item.UnitRate * value; 
                if ((itemsweight + value) <= itemstock.Weight) {
                     
                    item[field] = value;
                }
                this.view.updateItem(id, item);
                this.view.refresh();
            }
            for (var i = 0; i < items.length; i++) {
                if (items[i].SKU == item.SKU) {
                    items[i] == item;
                }
            }

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }



        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button"); 
            return buttons;
        }



        // #endregion




    }
}